import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  useToast,
  SimpleGrid,
} from "@chakra-ui/react";
import axios from "axios";
import { useUser } from "../../../context/UserContext";
import * as mod from "../../../url";

const CreateUserModal = ({ isOpen, onClose, onSuccess }) => {
  const { user } = useUser();
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    email: "",
    mobile: "",
    password: "",
    role: "player",
    status: "active",
  });
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [availableRoles, setAvailableRoles] = useState([]);

  useEffect(() => {
    if (user) {
      let roles = [];
      if (user.role === "admin") {
        roles = [
          { value: "player", label: "Player" },
          // { value: "agent", label: "Agent" },
        ];
      } else if (user.role === "super-admin") {
        roles = [
          { value: "player", label: "Player" },
          // { value: "agent", label: "Agent" },
          { value: "admin", label: "Admin" },
        ];
      }
      setAvailableRoles(roles);
      // Set default role to first available
      if (roles.length > 0) {
        setFormData((prev) => ({ ...prev, role: roles[0].value }));
      }
    }
  }, [user, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.post(`${mod.api_url}/users/add`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (data) {
        toast({
          title: "User Created",
          description: `User ${data.user.username} has been created successfully.`,
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });
        setFormData({
          name: "",
          username: "",
          email: "",
          mobile: "",
          password: "",
          role: "player",
          status: "active",
        });
        if (onSuccess) onSuccess();
        onClose();
      }
    } catch (error) {
      toast({
        title: "Error Creating User",
        description:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Create New User</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
            <FormControl isRequired>
              <FormLabel>Username</FormLabel>
              <Input
                name="username"
                value={formData.username}
                onChange={handleChange}
                placeholder="e.g. john_doe"
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>Email</FormLabel>
              <Input
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="e.g. john@example.com"
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>Mobile</FormLabel>
              <Input
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                placeholder="e.g. 9876543210"
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>Password</FormLabel>
              <Input
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="********"
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>Role</FormLabel>
              <Select name="role" value={formData.role} onChange={handleChange}>
                {availableRoles.map((r) => (
                  <option key={r.value} value={r.value}>
                    {r.label}
                  </option>
                ))}
              </Select>
            </FormControl>
          </SimpleGrid>
        </ModalBody>

        <ModalFooter>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={handleSubmit}
            isLoading={loading}
          >
            Create User
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CreateUserModal;
